.y{width:100%;}